import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class MrpV2Services {
  // create mrp v2
  createMrpV2 = async (payload) => {
    const mrp = await Helpers.post({
      url: `${Constants.MRP_V2}`,
      data: payload,
    });
    return mrp;
  }

  // get mrp v2
  getMrpV2 = async (tenantId, listScreen, mrpId, searchKeyword, status, fromDate, toDate, page, limit) => {
    let url = `${Constants.MRP_V2}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (listScreen) url += `list_screen=${listScreen}&`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (status) url += `status=${status}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    const mrp = await Helpers.get({
      url,
    });
    return mrp;
  }

  // Get Production Items
  getProductionItems = async (mrpId) => {
    let url = `${Constants.MRP_V2}/mrp_production?`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    const mrp = await Helpers.get({
      url,
    });
    return mrp;
  }

  // Get Stock Items
  getStockItems = async (mrpId, entityType) => {
    let url = `${Constants.MRP_V2}/mrp_stock_items?`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    if (entityType) url += `type=${entityType}&`;
    const mrp = await Helpers.get({
      url,
    });
    return mrp;
  }

  // link so to Mrp
  LinkSoToMRP = async (payload) => {
    const so = await Helpers.post({
      url: `${Constants.MRP_V2}/link_so`,
      data: payload,
    });
    return so;
  }

  // Push To Production Items
  pushToProductionItems = async (payload) => {
    const item = await Helpers.post({
      url: `${Constants.MRP_V2}/push_to_mrp_production`,
      data: payload,
    });
    return item;
  }

  // Push To Stock Items
  pushToStockItems = async (payload) => {
    const items = await Helpers.post({
      url: `${Constants.MRP_V2}/push_to_stock_items`,
      data: payload,
    });
    return items;
  }

  // update mrp v2
  updateMrpV2 = async (payload) => {
    const mrp = await Helpers.put({
      url: `${Constants.MRP_V2}`,
      data: payload,
    });
    return mrp;
  }

  // Update MRP Production
  updateMrpProduction = async (payload) => {
    const mrp = await Helpers.put({
      url: `${Constants.MRP_V2}/update_mrp_production`,
      data: payload,
    });
    return mrp;
  }

  // Get Linked MOs
  getLinkedMO = async (mrpId) => {
    let url = `${Constants.MRP_V2}/linked_mo?`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    const linkedMO = await Helpers.get({
      url,
    });
    return linkedMO;
  }

  // update MRP Stock Items
  updateMrpStockItems = async (payload) => {
    const mrp = await Helpers.put({
      url: `${Constants.MRP_V2}/mrp_stock_item`,
      data: payload,
    });
    return mrp;
  }

  // Link Mo to Mrp
  linkMoToMrp = async (payload) => {
    const mo = await Helpers.post({
      url: `${Constants.MRP_V2}/link_mo`,
      data: payload,
    });
    return mo;
  }

  // LINK PO to Mrp
  linkPoToMrp = async (payload) => {
    const mo = await Helpers.post({
      url: `${Constants.MRP_V2}/link_po`,
      data: payload,
    });
    return mo;
  }

  // unlink so to Mrp
  unlinkSoToMRP = async (payload) => {
    const so = await Helpers.post({
      url: `${Constants.MRP_V2}/unlink_so`,
      data: payload,
    });
    return so;
  }

  // Reserve Shortage
  reserveShortageMrp = async (payload) => {
    const reserveShortage = await Helpers.post({
      url: `${Constants.MRP_V2}/reserve_shortage`,
      data: payload,
    });
    return reserveShortage;
  }

  // unlink mo to Mrp
  unlinkMoToMRP = async (payload) => {
    const mo = await Helpers.post({
      url: `${Constants.MRP_V2}/unlink_mo`,
      data: payload,
    });
    return mo;
  }

  // unlink mo to Mrp
  unlinkPoToMRP = async (payload) => {
    const po = await Helpers.post({
      url: `${Constants.MRP_V2}/unlink_po`,
      data: payload,
    });
    return po;
  }

  // close mrp plan
  closeMrpPlan = async (payload) => {
    const mrp = await Helpers.put({
      url: `${Constants.MRP_V2}/update_status`,
      data: payload,
    });
    return mrp;
  }

  /**
   *
   * @param mrpId
   * @returns {Promise<*>}
   */
  getMrpSummary = async (mrpId) => {
    const mrpSummary = await Helpers.get({
      url: `${Constants.MRP_V2}/summary?mrp_id=${mrpId}`,
    });
    return mrpSummary;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  clearReservation = async (payload) => {
    const reservation = await Helpers.post({
      url: `${Constants.MRP_V2}/clear_reservations`,
      data: payload,
    });
    return reservation;
  }

  /**
   *
   * @param mrpId
   * @returns {Promise<*>}
   */
  deleteMrpV2 = async (mrpId) => {
    const reservation = await Helpers.delete({
      url: `${Constants.MRP_V2}?mrp_id=${mrpId}`,
    });
    return reservation;
  }

  // link existing po to mrp
  getLinkExistingPoToMrp = async ({ tenantId, searchKeyword, fromDate, toDate, edd, productSkuIds, tags, departmentIds }) => {
    let url = `${Constants.MRP_V2}/open_purchase_orders?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (edd) url += `edd=${edd}&`;
    if (productSkuIds) url += `product_sku_ids=${productSkuIds}&`;
    if (tags) url += `tags=${tags}&`;
    if (departmentIds) url += `department_ids=${departmentIds}&`;

    const po = await Helpers.get({
      url,
    });
    return po;
  }

  LinkExistingPoToMrp = async (payload) => {
    const linkPo = await Helpers.post({
      url: `${Constants.MRP_V2}/link_po_lines`,
      data: payload,
    });
    return linkPo;
  }

  // link Already po to mrp
  getAlreadyLinkedPoToMrp = async ({ mrpId, productSkuIds }) => {
    let url = `${Constants.MRP_V2}/linked_po_lines?`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    if (productSkuIds) url += `product_sku_id=${productSkuIds}&`;

    const LinkedPos = await Helpers.get({
      url,
    });
    return LinkedPos;
  }

  unlinkLinkedPoToMrp = async (payload) => {
    const unLinkPo = await Helpers.post({
      url: `${Constants.MRP_V2}/unlink_po_lines`,
      data: payload,
    });
    return unLinkPo;
  }

  updateLinkedPoToMrp = async (payload) => {
    const unLinkPo = await Helpers.put({
      url: `${Constants.MRP_V2}/update_linked_po_lines`,
      data: payload,
    });
    return unLinkPo;
  }
}

export default new MrpV2Services();
